import { IExternalScriptExecutable } from ".";

export interface IExternalDataApplicable extends IExternalScriptExecutable {
  row: number;
  column: number;
  value: any;
  previousCsvBinary: string;
  isExternalDataCellParameterMatched(name: string, row: number, column: number): boolean;
  getValueForExternalScript(): string;
  setValueFromExternalScript(value: string): void;
  adjustFontSize(): void;
}

export function instanceOfIExternalDataApplicable(instance: any): instance is IExternalDataApplicable {
  return instance
    && (instance.row !== undefined)
    && (instance.column !== undefined)
    && (instance.isExternalDataCellParameterMatched !== undefined);
}
